export const lighterGrey = "rgb(250, 250, 250)";
export const lightGrey = "rgb(238, 238, 238)";
export const mediumGrey = "rgb(102, 102, 102)";
export const darkGrey = "rgb(33, 33, 33)";
export const green = "rgb(106, 203, 67)";
export const pompadour = "rgb(115, 42, 80)";



// WEBPACK FOOTER //
// ./src/colors.js